import { defineMessages } from 'react-intl';

const messages = defineMessages({
  aiDescription: {
    defaultMessage: 'Use Watson’s AI or build your own machine learning models',
    id: 'tvJ7wf',
  },
  aiName: {
    defaultMessage: 'AI & machine learning',
    id: 'dMFZIJ',
  },
  aixDescription: {
    defaultMessage: 'UNIX operating system for Power servers',
    id: 'AXWEo7',
  },
  aixName: {
    defaultMessage: 'AIX',
    id: '/cV+Lj',
  },
  analyticsDescription: {
    defaultMessage: 'Aggregate and analyze large datasets',
    id: 'qgPKkY',
  },
  analyticsEngineDescription: {
    defaultMessage:
      'PaaS to build analytics applications on Apache Spark and Hadoop ',
    id: '/xOV9k',
  },
  analyticsEngineName: {
    defaultMessage: 'IBM Analytics Engine',
    id: '3HMsx5',
  },
  analyticsName: {
    defaultMessage: 'Analytics',
    id: 'GZJpDf',
  },
  apiConnectDescription: {
    defaultMessage: 'Toolkit to rapidly create, secure and manage APIs',
    id: 'YWkllQ',
  },
  apiConnectName: {
    defaultMessage: 'API Connect',
    id: 'JF4ZsH',
  },
  appConfigurationDescription: {
    defaultMessage: 'SDK, dashboard and API for application feature management',
    id: 'VrOy6P',
  },
  appConfigurationName: {
    defaultMessage: 'IBM Cloud App Configuration',
    id: '+9vdTn',
  },
  appConnectDescription: {
    defaultMessage: 'Codeless connectors for your data, apps and APIs',
    id: '4bbD8a',
  },
  appConnectName: {
    defaultMessage: 'APP Connect',
    id: 'tVAwCo',
  },
  appHeadline: {
    defaultMessage: 'Explore products',
    id: 'cSc9Vc',
  },
  appLearnMore: {
    defaultMessage: 'Learn more',
    id: 'TdTXXf',
  },
  appSubhead: {
    defaultMessage:
      'A full stack cloud platform with over 170 products and services covering data, containers, AI, IoT, and blockchain.',
    id: '3plg7d',
  },
  appSubheadB: {
    defaultMessage:
      'Use your existing infrastructure—even edge or other public clouds—with IBM Cloud services, APIs, access policies, security controls and compliance with ',
    id: 'bA3qoG',
  },
  appSubheadC: {
    defaultMessage: 'IBM Cloud Satellite.',
    id: 'oY96j3',
  },
  asperaDescription: {
    defaultMessage: 'System to transfer, sync or stream huge data globally',
    id: 'GYVnTC',
  },
  asperaName: {
    defaultMessage: 'Aspera',
    id: 'IUJKDE',
  },
  assetManagementDescription: {
    defaultMessage: 'Manage and maintain physical assets',
    id: 'ukF5XF',
  },
  assetManagementName: {
    defaultMessage: 'Asset management',
    id: 'ClOJNq',
  },
  automationDescription: {
    defaultMessage: 'Automate workflows and business processes',
    id: 'Q8knEM',
  },
  automationName: {
    defaultMessage: 'Business automation',
    id: 'fyUCiJ',
  },
  baWorkflowDescription: {
    defaultMessage:
      'Cloud Pak for Business Automation addon to automate workflows',
    id: 'obFgUA',
  },
  baWorkflowName: {
    defaultMessage: 'Business Automation Workflow',
    id: 'a3Achx',
  },
  bareMetalDescription: {
    defaultMessage: 'Dedicated hardware for maximum performance',
    id: '6H+967',
  },
  bareMetalName: {
    defaultMessage: 'Cloud Bare Metal Servers',
    id: 'r24dl4',
  },
  blockchainDescription: {
    defaultMessage: 'Build applications on an immutable blockchain ledger',
    id: 'w3AaOs',
  },
  blockchainName: {
    defaultMessage: 'Blockchain',
    id: 'OkWAlI',
  },
  blockchainPlatformDescription: {
    defaultMessage: 'Blockchain SDK based on Hyperledger Fabric',
    id: 'fZYnzi',
  },
  blockchainPlatformName: {
    defaultMessage: 'IBM Blockchain Platform',
    id: 'CAhGT6',
  },
  blueworksDescription: {
    defaultMessage: 'SaaS for collaboratively modeling business processes',
    id: 'd86ZxR',
  },
  blueworksName: {
    defaultMessage: 'BlueWorks Live',
    id: 'ghWFfO',
  },
  browseProducts: {
    defaultMessage: 'Browse our products',
    id: 'ReLiBu',
  },
  ccDeliveryDescription: {
    defaultMessage:
      'UI and CLI based DevOps workflows based on Tekton Pipelines',
    id: 'KqvGDN',
  },
  ccDeliveryName: {
    defaultMessage: 'Cloud Continuous Delivery',
    id: 'SQLsDC',
  },
  cloudAllDescription: {
    defaultMessage: 'On-demand cloud computing platform and APIs',
    id: 'XT2YLR',
  },
  cloudAllName: {
    defaultMessage: 'IBM Cloud',
    id: 'DtAbSb',
  },
  cloudCliDescription: {
    defaultMessage: 'A CLI to manage your IBM Cloud',
    id: '8C8NDW',
  },
  cloudCliName: {
    defaultMessage: 'IBM Cloud CLI',
    id: '4TUmUg',
  },
  cloudFunctionsDescription: {
    defaultMessage: 'Serverless function runtime based on Apache OpenWhisk',
    id: 'Cke3Eg',
  },
  cloudFunctionsName: {
    defaultMessage: 'IBM Cloud Functions',
    id: 'Gz0Q3f',
  },
  cloudSchematicsDescription: {
    defaultMessage:
      'Managed service to provision resources with terraform templates',
    id: 'O7DLNZ',
  },
  cloudSchematicsName: {
    defaultMessage: 'Cloud Schematics',
    id: '80GKZJ',
  },
  cloudantDescription: {
    defaultMessage: 'Managed PCI-compliant JSON document store on CouchDB',
    id: '4t44vN',
  },
  cloudantName: {
    defaultMessage: 'Cloudant',
    id: '7F/9Of',
  },
  cloudpakbaDescription: {
    defaultMessage: 'Operations management software with AI insights',
    id: 'Bjs0bd',
  },
  cloudpakbaName: {
    defaultMessage: 'Cloud Pak for Business Automation',
    id: 'O0s43Y',
  },
  cloudpaknaDescription: {
    defaultMessage: 'Management software for telco network operations',
    id: 'RfQ1sv',
  },
  cloudpaknaName: {
    defaultMessage: 'Cloud Pak for Network Automation',
    id: 'W2EwZS',
  },
  codeEngineDescription: {
    defaultMessage: 'Serverless container hosting platform as a service',
    id: 'QXONVT',
  },
  codeEngineName: {
    defaultMessage: 'IBM Cloud Code Engine',
    id: 'cecQ6e',
  },
  cognosAnalyticsDescription: {
    defaultMessage:
      'Software for business intelligence and performance management',
    id: '0ArCSU',
  },
  cognosAnalyticsName: {
    defaultMessage: 'Cognos Analytics',
    id: 'zdoyJ8',
  },
  computeDescription: {
    defaultMessage: 'Run workloads on cloud infrastructure',
    id: 'YTFqSU',
  },
  computeName: {
    defaultMessage: 'Compute & servers',
    id: 'OmVJZ3',
  },
  containerRegistryDescription: {
    defaultMessage: 'SaaS for container storage and management',
    id: 'fyaRux',
  },
  containerRegistryName: {
    defaultMessage: 'Container registry',
    id: 'A5T/sB',
  },
  containersDescription: {
    defaultMessage: 'Deploy applications consistently across environments',
    id: 'u9zWS+',
  },
  containersName: {
    defaultMessage: 'Containers',
    id: 'TDDlIs',
  },
  continuousDeliveryDescription: {
    defaultMessage:
      'UI and CLI based DevOps workflows based on Tekton Pipelines',
    id: 'KqvGDN',
  },
  continuousDeliveryName: {
    defaultMessage: 'IBM Cloud Continuous Delivery',
    id: 'd0J9+U',
  },
  cplexDescription: {
    defaultMessage: 'Software to build and solve complex optimization models',
    id: '4jY/SC',
  },
  cplexName: {
    defaultMessage: 'CPLEX',
    id: 'E/2d4y',
  },
  dataPowerDescription: {
    defaultMessage: 'Physical or virtual multi-protocol network gateway',
    id: 'OoJLL3',
  },
  dataPowerName: {
    defaultMessage: 'DataPower',
    id: 'UF4YdG',
  },
  databasesDescription: {
    defaultMessage: 'Store, query and analyze structured data',
    id: 'SAgOYa',
  },
  databasesForElasticsearchDescription: {
    defaultMessage: 'Managed JSON document store for full-text search',
    id: 'yC3Bny',
  },
  databasesForElasticsearchName: {
    defaultMessage: 'IBM Cloud Databases for Elasticsearch',
    id: 'bw4KmR',
  },
  databasesForMongodbDescription: {
    defaultMessage: 'Managed NoSQL JSON document store',
    id: 'mXhQDU',
  },
  databasesForMongodbName: {
    defaultMessage: 'IBM Cloud Databases for MongoDB',
    id: 'YLUpsk',
  },
  databasesForMysqlDescription: {
    defaultMessage: 'Managed SQL database',
    id: '7E1J9z',
  },
  databasesForMysqlName: {
    defaultMessage: 'IBM Cloud Databases for MySQL',
    id: 'yPSXlW',
  },
  databasesForPostgresqlDescription: {
    defaultMessage: 'Managed SQL database with advanced features',
    id: '/O+MYb',
  },
  databasesForPostgresqlName: {
    defaultMessage: 'IBM Cloud Databases for PostgreSQL',
    id: 'iEOCYm',
  },
  databasesName: {
    defaultMessage: 'Database',
    id: 'jjTzIr',
  },
  db2Description: {
    defaultMessage: 'Data management software including IBM Db2 Database',
    id: 'ML157b',
  },
  db2Name: {
    defaultMessage: 'Db2',
    id: 'Uc89DT',
  },
  db2ZOSDescription: {
    defaultMessage: 'IBM Db2 Database for IBM Z mainframes',
    id: 'gk5asS',
  },
  db2ZOSName: {
    defaultMessage: 'Db2 for z/OS',
    id: 'cOWsJw',
  },
  developerToolsDescription: {
    defaultMessage: 'Manage infrastructure, environments and deployments',
    id: 'a2I/+Q',
  },
  developerToolsName: {
    defaultMessage: 'Developer tools',
    id: 'g/w+Mb',
  },
  devopsDescription: {
    defaultMessage: 'Manage infrastructure, environments and deployments',
    id: 'a2I/+Q',
  },
  devopsName: {
    defaultMessage: 'DevOps',
    id: 'HlROur',
  },
  ds8900fDescription: {
    defaultMessage:
      'Mainframe attached storage for transaction intensive workloads',
    id: '20oBHj',
  },
  ds8900fName: {
    defaultMessage: 'DS8900F',
    id: '9Msi1O',
  },
  edgeAppDescription: {
    defaultMessage: 'Management platform for edge computing',
    id: 'bCwFMD',
  },
  edgeAppName: {
    defaultMessage: 'Edge Application Manager',
    id: 'O0jmwX',
  },
  elasticStorageDescription: {
    defaultMessage: 'Distributed storage for AI, big data and HPC workloads',
    id: 'hnoNqQ',
  },
  elasticStorageName: {
    defaultMessage: 'Elastic Storage System',
    id: 'l3vbHL',
  },
  engineeringLifecycleDescription: {
    defaultMessage: 'Software for product and application lifecycle management',
    id: 'fPsLuE',
  },
  engineeringLifecycleName: {
    defaultMessage: 'Engineering Lifecycle Management',
    id: 'i7d3oY',
  },
  environmentIntelligenceDescription: {
    defaultMessage:
      'SaaS for predicting and responding to weather and climate events',
    id: 'S3ZQao',
  },
  environmentIntelligenceName: {
    defaultMessage: 'Environmental Intelligence Suite',
    id: 'I/dnhd',
  },
  enviziDescription: {
    defaultMessage:
      'SaaS to analyze environmental, social and governance indicators',
    id: '8YymYu',
  },
  enviziName: {
    defaultMessage: 'Envizi',
    id: 'mb05kD',
  },
  eventStreamsDescription: {
    defaultMessage: 'PaaS stream processing based on Apache Kafka',
    id: '7xSb+w',
  },
  eventStreamsName: {
    defaultMessage: 'Event Streams',
    id: 'AYwysK',
  },
  featuredDescription: {
    defaultMessage:
      'Our flagship products for enterprise hybrid cloud infrastructure',
    id: 'av3k/6',
  },
  featuredName: {
    defaultMessage: 'Featured',
    id: 'CnPG8j',
  },
  filenetDescription: {
    defaultMessage:
      'Content management solution for Cloud Pak for Business Automation',
    id: 'eNmZ4L',
  },
  filenetName: {
    defaultMessage: 'FileNet Content Manager',
    id: 'ht5nHm',
  },
  flashSystemDescription: {
    defaultMessage:
      'Primary storage for performance and latency sensitive workloads',
    id: 'i8Bvzv',
  },
  flashSystemName: {
    defaultMessage: 'FlashSystem',
    id: '1dUiiW',
  },
  flexeraDescription: {
    defaultMessage: 'IT asset management and cloud optimization',
    id: 'OjLLrA',
  },
  flexeraName: {
    defaultMessage: 'Flexera One',
    id: 'MqLJLo',
  },
  guardiumDescription: {
    defaultMessage: 'Software and hardware appliances for database security',
    id: 'OVGkWO',
  },
  guardiumName: {
    defaultMessage: 'Guardium',
    id: 'Bxnxkn',
  },
  horizonDescription: {
    defaultMessage: 'Virtual desktops, in the cloud and managed',
    id: '/NWI1J',
  },
  horizonName: {
    defaultMessage: 'Dizzion Managed DaaS on IBM Cloud',
    id: 'vPqMb0',
  },
  hyperDbaasDescription: {
    defaultMessage: 'Managed PostgreSQL and MongoDB for sensitive data',
    id: 'R/fawH',
  },
  hyperDbaasName: {
    defaultMessage: 'Hyper Protect DbaaS',
    id: 'g7QoR1',
  },
  hyperProtectVirtualServersDescription: {
    defaultMessage: 'Virtual servers for workloads with sensitive data',
    id: 'nmblXM',
  },
  hyperProtectVirtualServersName: {
    defaultMessage: 'IBM Hyper Protect Virtual Servers',
    id: 'vfoXSK',
  },
  ibmCloudPaksDescription: {
    defaultMessage:
      'Integrated and certified applications on Red Hat OpenShift',
    id: '9L6a1L',
  },
  ibmCloudPaksName: {
    defaultMessage: 'IBM Cloud Paks',
    id: 'SgxPaA',
  },
  ibmIDescription: {
    defaultMessage: 'Integrated operating system for Power servers',
    id: '7XDjNC',
  },
  ibmIName: {
    defaultMessage: 'IBM i',
    id: 'Lx6YjU',
  },
  imsDescription: {
    defaultMessage:
      'Database and management system for high-volume transactions',
    id: 'aGkdPz',
  },
  imsName: {
    defaultMessage: 'IMS',
    id: '2QFi5S',
  },
  infoServerDescription: {
    defaultMessage: 'Data integration suite for ETL, governance and anlaysis',
    id: '0uWolc',
  },
  infoServerName: {
    defaultMessage: 'Information Server',
    id: 'QA8vVz',
  },
  informixDescription: {
    defaultMessage:
      'Embeddable database for SQL, NoSQL, time-series and spatial data',
    id: 'EtZ6Gr',
  },
  informixName: {
    defaultMessage: 'Informix',
    id: 'gsALQy',
  },
  instanaDescription: {
    defaultMessage:
      'Software for application performance monitoring and automation',
    id: '9ldkt3',
  },
  instanaName: {
    defaultMessage: 'Instana',
    id: 'Iu+et8',
  },
  istioDescription: {
    defaultMessage: 'A service mesh for microservices in Kubernetes clusters',
    id: 'pIUXrB',
  },
  istioName: {
    defaultMessage: 'Istio',
    id: 'WhpOBd',
  },
  itAutomationDescription: {
    defaultMessage: 'Automate IT infrastructure mangement',
    id: 'm31pPO',
  },
  itAutomationName: {
    defaultMessage: 'IT automation',
    id: 'Ndxq0w',
  },
  kubernetesDescription: {
    defaultMessage:
      'Container hosting with self-healing and horizontal scaling',
    id: 'WBSGau',
  },
  kubernetesName: {
    defaultMessage: 'IBM Cloud Kubernetes Service',
    id: '0UBJ54',
  },
  linuxOneDescription: {
    defaultMessage: 'Physical and virtual servers for running Linux',
    id: 'VdcXx9',
  },
  linuxOneName: {
    defaultMessage: 'LinuxONE',
    id: 'Oq+/5X',
  },
  maas360Description: {
    defaultMessage:
      'Unified endpoint management software for many device types',
    id: 'SPA9oP',
  },
  maas360Name: {
    defaultMessage: 'MaaS360',
    id: 'T1A3fx',
  },
  maximoDescription: {
    defaultMessage: 'Software for asset management and related workflows',
    id: 'YkL540',
  },
  maximoName: {
    defaultMessage: 'Maximo',
    id: 'jhOXHZ',
  },
  mdmDescription: {
    defaultMessage: 'Managed master data storage',
    id: 'CQilD5',
  },
  mdmName: {
    defaultMessage: 'IBM Master Data Management on Cloud',
    id: 'hUqsVf',
  },
  messagesForRabbitmqDescription: {
    defaultMessage: 'Managed message broker',
    id: 'p33z2x',
  },
  messagesForRabbitmqName: {
    defaultMessage: 'IBM Cloud Messages for RabbitMQ',
    id: 'C8DVFE',
  },
  middlewareDescription: {
    defaultMessage: 'Connect your applications, data and events',
    id: 'o+wv74',
  },
  middlewareName: {
    defaultMessage: 'Middleware',
    id: 'XmJcGY',
  },
  mqDescription: {
    defaultMessage:
      'Software and hardware for messaging between distributed systems',
    id: 'sP4DPM',
  },
  mqName: {
    defaultMessage: 'MQ',
    id: 'YTEdaE',
  },
  netezzaDescription: {
    defaultMessage: 'Data warehousing and analytics system on custom hardware',
    id: 'YMKYFT',
  },
  netezzaName: {
    defaultMessage: 'Netezza',
    id: 'KmqBJZ',
  },
  networkDescription: {
    defaultMessage: 'Run and manage public, private and virtual networks',
    id: 'o5DTVG',
  },
  networkName: {
    defaultMessage: 'Network',
    id: 'I3JhPS',
  },
  objectStorageDescription: {
    defaultMessage: 'Unstructured cloud data storage with an API frontend',
    id: 'XzhFjl',
  },
  objectStorageName: {
    defaultMessage: 'Cloud Object Storage',
    id: 'sYRxSi',
  },
  openShiftDescription: {
    defaultMessage: 'Container hosting on managed Red Hat Linux servers',
    id: 'mpm2U2',
  },
  openShiftName: {
    defaultMessage: 'Red Hat® OpenShift® on IBM Cloud',
    id: 'iy++Ui',
  },
  operationalManagerDescription: {
    defaultMessage:
      'Cloud Pak for Business Automation addon for rule-based decisions',
    id: 'YduruB',
  },
  operationalManagerName: {
    defaultMessage: 'Operational Decision Manager',
    id: 'eipCzv',
  },
  optimDescription: {
    defaultMessage: 'Software to manage test, production, and archived data',
    id: '9VMkZJ',
  },
  optimName: {
    defaultMessage: 'Optim',
    id: 'bvB3FW',
  },
  osDescription: {
    defaultMessage: 'Run critical workloads on specialized operating systems',
    id: 'ZtUGBf',
  },
  osName: {
    defaultMessage: 'Operating system',
    id: 'n8cyVk',
  },
  pakDataDescription: {
    defaultMessage: 'Tools for data analysis, organization and management',
    id: 'YQrc3L',
  },
  pakDataName: {
    defaultMessage: 'Cloud Pak for Data',
    id: 'Tc9FAx',
  },
  pakIntegrationDescription: {
    defaultMessage: 'Tools to connect all of your apps, data and events',
    id: 'rlKHBE',
  },
  pakIntegrationName: {
    defaultMessage: 'Cloud Pak for Integration',
    id: 'dit0EH',
  },
  pakSecurityDescription: {
    defaultMessage: 'Security auditing, reporting, analysis and governance',
    id: 'JCGVvu',
  },
  pakSecurityName: {
    defaultMessage: 'Cloud Pak for Security',
    id: 'aUtHgQ',
  },
  planningAnalyticsDescription: {
    defaultMessage: 'Software to automate financial and operational planning',
    id: 'prps3r',
  },
  planningAnalyticsName: {
    defaultMessage: 'Planning Analytics',
    id: 'P2O1MZ',
  },
  powerDescription: {
    defaultMessage: 'Physical and virtual servers with IBM Power CPUs',
    id: '5OHrfy',
  },
  powerName: {
    defaultMessage: 'Power',
    id: 'YXoHk0',
  },
  powerVirtualServerDescription: {
    defaultMessage: 'Virtual servers with IBM POWER processors',
    id: 'OvH4dR',
  },
  powerVirtualServerName: {
    defaultMessage: 'IBM Power Systems Virtual Servers',
    id: '5ftS+u',
  },
  processMiningDescription: {
    defaultMessage:
      'Software to extract process data from business applications',
    id: 'Ne/hTm',
  },
  processMiningName: {
    defaultMessage: 'Process Mining',
    id: 'A6ofou',
  },
  qiskitDescription: {
    defaultMessage: 'Python SDK for open-source quantum development',
    id: '6+Wt0y',
  },
  qiskitName: {
    defaultMessage: 'Qiskit',
    id: 'IKkrDs',
  },
  qradarConnectDescription: {
    defaultMessage: 'Software to monitor and mitigate security threats with AI',
    id: 'HdAJut',
  },
  qradarConnectName: {
    defaultMessage: 'QRadar XDR Connect',
    id: 'IRswsJ',
  },
  qradarSiemDescription: {
    defaultMessage:
      'Software and network appliances for real-time security analysis',
    id: '9CcWX6',
  },
  qradarSiemName: {
    defaultMessage: 'QRadar SIEM',
    id: '6XIGSx',
  },
  qradarSoarDescription: {
    defaultMessage: 'Software for security event response workflow automation',
    id: 'TmaSjh',
  },
  qradarSoarName: {
    defaultMessage: 'QRadar SOAR',
    id: 'yC7QeQ',
  },
  qskitRuntimeDescription: {
    defaultMessage: 'Python SDK for open source quantum development',
    id: '9CieuE',
  },
  qskitRuntimeName: {
    defaultMessage: 'Qskit Runtime',
    id: 'mLTMBv',
  },
  quantumDescription: {
    defaultMessage: 'Run code on real quantum systems using a full-stack SDK',
    id: 'VQUAYA',
  },
  quantumName: {
    defaultMessage: 'Quantum',
    id: 'i956Rq',
  },
  quantumSafeDescription: {
    defaultMessage:
      'Get help migrating your organization to quantum-safe cryptography',
    id: 'C45YKl',
  },
  quantumSafeName: {
    defaultMessage: 'Quantum Safe',
    id: '5KOuZq',
  },
  quantumSystemsDescription: {
    defaultMessage:
      'On-premise and IaaS hardware with up to 127 qubit processors',
    id: 'Azkf/S',
  },
  quantumSystemsName: {
    defaultMessage: 'Quantum Systems',
    id: 'G4NoxW',
  },
  reaqtaDescription: {
    defaultMessage: 'Hypervisor-based endpoint security automation software',
    id: 'MJWo6B',
  },
  reaqtaName: {
    defaultMessage: 'ReaQta',
    id: 'Ejyb7H',
  },
  roboticAutomationDescription: {
    defaultMessage: 'Software to automate workflows and business processes',
    id: '6hlPM0',
  },
  roboticAutomationName: {
    defaultMessage: 'Robotic Process Automation (RPA)',
    id: '7kRON8',
  },
  sanSwitchesDescription: {
    defaultMessage:
      'Networking hardware to connect hosts over fast data fabrics',
    id: 'Fj2g5C',
  },
  sanSwitchesName: {
    defaultMessage: 'SAN Switches',
    id: 'SO0dNR',
  },
  securityDescription: {
    defaultMessage:
      'Secure your cloud resources and simplify regulatory compliance',
    id: 'X28+9+',
  },
  securityIdentityDescription: {
    defaultMessage: 'Secure your resources and simplify regulatory compliance',
    id: 'myncOw',
  },
  securityIdentityName: {
    defaultMessage: 'Security & identity',
    id: 'cPYkEV',
  },
  securityName: {
    defaultMessage: 'Security',
    id: 'Py189G',
  },
  sevOneDescription: {
    defaultMessage: 'Software to collect and analyze network performance data',
    id: 'OOVhus',
  },
  sevOneName: {
    defaultMessage: 'SevOne Network Performance Management',
    id: 'D/eJcj',
  },
  spectrumComputingDescription: {
    defaultMessage: 'Software to manage large-scale storage devices and data',
    id: 'V4/ssg',
  },
  spectrumComputingName: {
    defaultMessage: 'Spectrum Computing',
    id: 'jg6VvZ',
  },
  spectrumFusionDescription: {
    defaultMessage:
      'Container-native storage for Red Hat OpenShift and Kubernetes',
    id: '8X8UsF',
  },
  spectrumFusionName: {
    defaultMessage: 'Spectrum Fusion',
    id: 'eLKA11',
  },
  spectrumProtectDescription: {
    defaultMessage: 'Data resiliency, backup and recovery delivered via SaaS',
    id: 'vNVAXE',
  },
  spectrumProtectName: {
    defaultMessage: 'Spectrum Protect',
    id: 'f0PY5O',
  },
  spssDescription: {
    defaultMessage:
      'Software for statistical analysis and business intelligence',
    id: 'T98xJ0',
  },
  spssName: {
    defaultMessage: 'SPSS',
    id: 'uWKb6s',
  },
  sqlQueryDescription: {
    defaultMessage: 'Query tool for IBM Cloud Object Storage',
    id: 'BglnoZ',
  },
  sqlQueryName: {
    defaultMessage: 'IBM Cloud SQL Query',
    id: 'U4y8Er',
  },
  sterlingDescription: {
    defaultMessage:
      'Software suite and network for complete supply chain management',
    id: 'jLEBtf',
  },
  sterlingName: {
    defaultMessage: 'Sterling',
    id: 'RevYo6',
  },
  storageDescription: {
    defaultMessage:
      'Hardware, software and services for edge to core to hybrid cloud',
    id: 'v7MMu5',
  },
  storageName: {
    defaultMessage: 'Storage',
    id: 'DUIDEq',
  },
  streamingAnalyticsDescription: {
    defaultMessage: 'Dashboard for real-time analysis of data streams',
    id: '4MGh22',
  },
  streamingAnalyticsName: {
    defaultMessage: 'IBM Streaming Analytics',
    id: 'pGC68e',
  },
  supplyChainDescription: {
    defaultMessage: 'Manage the flow of goods and services',
    id: 'vGyVq7',
  },
  supplyChainName: {
    defaultMessage: 'Supply chain',
    id: 'Mo8JdA',
  },
  supplyChainSuiteDescription: {
    defaultMessage: 'Software for supply chain optimization and automation',
    id: '90gmU4',
  },
  supplyChainSuiteName: {
    defaultMessage: 'Supply Chain Intelligence Suite',
    id: '8mmmVp',
  },
  tapeLibrariesDescription: {
    defaultMessage:
      'Long-term and physically air-gapped sustainable archival storage',
    id: '8SFJsd',
  },
  tapeLibrariesName: {
    defaultMessage: 'Tape Libraries',
    id: 'SjuleV',
  },
  tektonDescription: {
    defaultMessage: 'Kubernetes-native CI and CD pipelines',
    id: 'mzfhv8',
  },
  tektonName: {
    defaultMessage: 'Tekton',
    id: '8pvAuZ',
  },
  tririgaDescription: {
    defaultMessage: 'Software for real estate and workplace management',
    id: 'GWcBa6',
  },
  tririgaName: {
    defaultMessage: 'TRIRIGA',
    id: 'O9FNeH',
  },
  trusteerDescription: {
    defaultMessage:
      'Software to authenticate customers, detect fraud and assess risk',
    id: 'yyK2pl',
  },
  trusteerName: {
    defaultMessage: 'Trusteer',
    id: 'KpTckc',
  },
  turbonomicDescription: {
    defaultMessage: 'Software to manage and optimize IT resource usage',
    id: 'mwAAUo',
  },
  turbonomicName: {
    defaultMessage: 'Turbonomic',
    id: 'DtJzmb',
  },
  urbanCodeDescription: {
    defaultMessage:
      'Software for continuous integration and deployment pipelines',
    id: 'oWFxs6',
  },
  urbanCodeName: {
    defaultMessage: 'UrbanCode',
    id: 'dbhzxD',
  },
  verifyDescription: {
    defaultMessage: 'IAM software available on-premises or as SaaS',
    id: 'OHfgtA',
  },
  verifyName: {
    defaultMessage: 'Verify',
    id: 'q5Xl0M',
  },
  verifyPrivilegeDescription: {
    defaultMessage:
      'Endpoint privilege management and application control software',
    id: 'DuO+XN',
  },
  verifyPrivilegeName: {
    defaultMessage: 'Verify Privilege',
    id: 'x37jOz',
  },
  virtualServersDescription: {
    defaultMessage:
      'Virtual servers with the most flexible configuration options',
    id: 'c5ozcM',
  },
  virtualServersName: {
    defaultMessage: 'IBM Cloud Virtual Servers for Classic Infrastructure',
    id: '++WyHu',
  },
  vmwareSolutionsDescription: {
    defaultMessage: 'Hosting for virtualized workloads',
    id: '5DWH+i',
  },
  vmwareSolutionsName: {
    defaultMessage: 'IBM Cloud for VMware Solutions',
    id: 'EkcUrj',
  },
  vpcDescription: {
    defaultMessage: 'Virtual servers with Intel Xeon or IBM Z CPUs',
    id: '4tIhhG',
  },
  vpcName: {
    defaultMessage: 'Cloud Virtual Servers for VPC',
    id: 'weIxpA',
  },
  vpsHostingDescription: {
    defaultMessage: 'Easily manage fast-moving workloads.',
    id: 'Zojq+P',
  },
  vpsHostingName: {
    defaultMessage: 'IBM Cloud VPS Hosting',
    id: '1PewX/',
  },
  watsonAiopsDescription: {
    defaultMessage:
      'DevOps management tool with AI analysis and recommendations',
    id: 'WtlKy/',
  },
  watsonAiopsName: {
    defaultMessage: 'Cloud Pak for AIOps',
    id: 'DV0P/D',
  },
  watsonAssistantDescription: {
    defaultMessage: 'Virtual agents customizable to any domain',
    id: 'ZNJrOS',
  },
  watsonAssistantName: {
    defaultMessage: 'Watson Assistant',
    id: 'HWwgaZ',
  },
  watsonCatalogDescription: {
    defaultMessage: 'SaaS for AI data management',
    id: 'qIvTZ4',
  },
  watsonCatalogName: {
    defaultMessage: 'Watson Knowledge Catalog',
    id: 'CtgmVb',
  },
  watsonDiscoveryDescription: {
    defaultMessage: 'Search and analytics engine that adapts to custom domains',
    id: 'njUA7c',
  },
  watsonDiscoveryName: {
    defaultMessage: 'Watson Discovery',
    id: 'bnlEMr',
  },
  watsonKnowledgeStudioDescription: {
    defaultMessage:
      'Visual interface to teach Watson domain-specific knowledge',
    id: 'yaKewA',
  },
  watsonKnowledgeStudioName: {
    defaultMessage: 'IBM Watson Knowledge Studio',
    id: 'rlq8Fg',
  },
  watsonLanguageClassifierDescription: {
    defaultMessage: 'Visual tool and API for text classification',
    id: 'nN08p2',
  },
  watsonLanguageClassifierName: {
    defaultMessage: 'IBM Watson Natural Language Classifier',
    id: 'Udbq5C',
  },
  watsonLanguageTranslatorDescription: {
    defaultMessage: 'API for translation with domain-specific models',
    id: 'y3M3RD',
  },
  watsonLanguageTranslatorName: {
    defaultMessage: 'IBM Watson Language Translator',
    id: 'ScFEs1',
  },
  watsonLanguageUnderstandingDescription: {
    defaultMessage: 'API for text analysis and metadata extraction',
    id: 'x/h7yL',
  },
  watsonLanguageUnderstandingName: {
    defaultMessage: 'IBM Watson Natural Language Understanding',
    id: 'ZZG8Oi',
  },
  watsonNluDescription: {
    defaultMessage: 'API for text analysis and metadata extraction',
    id: 'x/h7yL',
  },
  watsonNluName: {
    defaultMessage: 'Watson NLU',
    id: 'eR1UiX',
  },
  watsonOrchestrateDescription: {
    defaultMessage:
      'Personal-assistant software that automates repetitive tasks',
    id: 'rRu7MP',
  },
  watsonOrchestrateName: {
    defaultMessage: 'Watson Orchestrate',
    id: 'Anbz+x',
  },
  watsonSpeechToTextDescription: {
    defaultMessage: 'API for real-time speech recognition and transcription',
    id: 'LIuKA0',
  },
  watsonSpeechToTextName: {
    defaultMessage: 'Watson Speech to Text',
    id: 'J9wZk3',
  },
  watsonStudioDescription: {
    defaultMessage: 'IDE to build, run and manage AI models',
    id: 'SIrkDV',
  },
  watsonStudioName: {
    defaultMessage: 'Watson Studio',
    id: 'yDFNLf',
  },
  watsonTextToSpeechDescription: {
    defaultMessage: 'API for real-time text to speech conversion',
    id: 'YwEQe3',
  },
  watsonTextToSpeechName: {
    defaultMessage: 'Watson Text to Speech',
    id: 'K/J8KC',
  },
  websphereAppDescription: {
    defaultMessage: 'Runtime and SDK for Java applications',
    id: 'DXendR',
  },
  websphereAppName: {
    defaultMessage: 'WebSphere Application Server',
    id: 'kcmFIq',
  },
  websphereDescription: {
    defaultMessage: 'Runtime and SDK for Java applications',
    id: 'DXendR',
  },
  websphereName: {
    defaultMessage: 'IBM WebSphere Application Server on Cloud',
    id: 'LRDydZ',
  },
  z15Description: {
    defaultMessage: 'Previous generation of the IBM Z mainframe',
    id: 'LaAmBs',
  },
  z15Name: {
    defaultMessage: 'z15',
    id: 'p7EUZ/',
  },
  z16Description: {
    defaultMessage:
      'Flagship mainframe with on-chip AI and quantum-safe cryptography',
    id: 'oef7zS',
  },
  z16Name: {
    defaultMessage: 'z16',
    id: 'oGYRlw',
  },
  zosDescription: {
    defaultMessage:
      'Flagship OS for continuous, high-volume mainframe operation',
    id: 'NN2tLS',
  },
  zosName: {
    defaultMessage: 'z/OS',
    id: 'LubzUJ',
  },
  ztpfDescription: {
    defaultMessage: 'Real-time operating system for mainframes',
    id: 'WWwhsz',
  },
  ztpfName: {
    defaultMessage: 'z/TPF',
    id: 'nHXYN4',
  },
});

export default messages;
